import { useState } from "react";

import { ErrorIcon } from "../../assets/icons/errorIcon";
import { getApiErrorMessage } from "../../utils/apiErrorUtils";

import PaulThinkingIndicator from "./PaulThinkingIndicator";

type TPaulTurnLoadErrorCardProps = {
	turnIdx: number;
	error: string;
	onRetry: () => Promise<void>;
};

const PaulTurnLoadErrorCard = ({
	turnIdx,
	error,
	onRetry,
}: TPaulTurnLoadErrorCardProps) => {
	const [isRetrying, setIsRetrying] = useState(false);
	const [retryError, setRetryError] = useState<
		string | null
	>(null);

	const handleRetry = async () => {
		if (isRetrying) {
			return;
		}

		setIsRetrying(true);
		setRetryError(null);
		try {
			await onRetry();
		} catch (retryFailure: unknown) {
			setRetryError(
				typeof retryFailure === "string"
					? retryFailure
					: getApiErrorMessage(
							retryFailure,
							"Paul still could not load this turn."
						)
			);
		} finally {
			setIsRetrying(false);
		}
	};

	return (
		<div
			className="paul-turn-load-error"
			role="group"
			aria-label={`Turn ${turnIdx + 1} unavailable`}
		>
			<div className="paul-turn-load-error__header">
				<ErrorIcon />
				<span>Turn {turnIdx + 1} unavailable</span>
			</div>
			<p className="paul-turn-load-error__body">
				{retryError ?? error}
			</p>
			<div className="paul-turn-load-error__footer">
				<button
					type="button"
					className="paul-turn-load-error__button"
					onClick={() => {
						void handleRetry();
					}}
					disabled={isRetrying}
				>
					{isRetrying ? "Retrying…" : "Retry turn"}
				</button>
				{isRetrying ? (
					<PaulThinkingIndicator
						variant="icon"
						status="connecting"
						message={`Retrying turn ${turnIdx + 1}`}
					/>
				) : null}
			</div>
		</div>
	);
};

export default PaulTurnLoadErrorCard;
